// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\CustomerBookingCountRuleResponse

import { BookingRuleType } from './enums.gen';

export type CustomerBookingCountRuleApiResponse = {
	type: BookingRuleType.CustomerBookingCount;
	minCount: number | null;
	maxCount: number | null;
};

export type CustomerBookingCountRule = {
	type: BookingRuleType.CustomerBookingCount;
	minCount: number | null;
	maxCount: number | null;
};

export function hydrateCustomerBookingCountRule(data: CustomerBookingCountRuleApiResponse): CustomerBookingCountRule {
	return { ...data };
}